<div class="card redeem-card rounded py-3 me-2 cursor-pointer">
  <div class="d-flex justify-content-center mb-2">
    <div class="back-button"></div>
    <img
      [ngClass]="{
        'image-opacity': campaignEntitlement.campaignRedemptions_Quantity == 0
      }"
      alt=""
      [src]="campaignEntitlement.image_URL"
      class="logo mb-3 rounded"
    />
    <ng-container *ngIf="campaignEntitlement.campaignRedemptions_Quantity == 0">
      <span class="back-button icon material-icons text-grey text-end"> lock </span>
    </ng-container>
    <ng-container *ngIf="campaignEntitlement.campaignRedemptions_Quantity > 0">
      <span class="back-button icon material-icons text-success text-end fw-bold"> check_circle </span>
    </ng-container>
  </div>
  <div class="text-center font-size-12 fw-bold">{{ campaignEntitlement.CampaignName }}</div>

  <div class="font-size-12 text-danger text-center pt-3">
    {{ 'offer.expiry' | translate }} {{ campaignEntitlement.Campaign_ExpiryDate | date : 'MMM dd, YYYY' }}
  </div>
</div>
